export const ScannerControlWidget = {
  ScannersTable: "scannersTable",
  WMSWidget: "wmsWidget",
  WMSLegend: "wmsLegend",
};
